export const FETCH_ORG_USERS_SUCCESS = "fetch_org_users_success";
export const FETCH_ORG_USERS_FAIL = "fetch_org_users_fail";
export const UPDATE_ORG_USER = "update_org_user";
export const REMOVE_ORG_USER = "remove_org_user";
export const FETCH_INVITATIONS_SUCCESS = "fetch_invitations_success";
export const FETCH_INVITATIONS_FAIL = "fetch_invitations_fail";
export const ADD_INVITATION = "add_invitation";
export const REMOVE_INVITATION = "remove_invitation";
